// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","profile":"Header_profile__rt0Qw","rotate":"Header_rotate__FL-ne"};